import { Navigate, Route, Routes } from "react-router-dom";
import Template from "../Layout/Template";
import {
  AboutUs,
  AccountSetting,
  AddNewAppointmentPage,
  AddNewPhoneNumber,
  AddPatientMedicalRecord,
  AddPrescriptionToPatient,
  AddPrescriptionToPatientByTemplate,
  Allergy,
  AppointmentsPage,
  ArticleDetails,
  Articles,
  ChangePassword,
  ChronicDiseases,
  ClinicAddress,
  ContactInfo,
  CreatePrescriptionTemplate,
  DoctorCertificate,
  DoctorCertificateDetails,
  DoctorCertificates,
  DoctorSpecialty,
  DomeCarePrivacyPolicy,
  EditClinicAddress,
  EditContactInfo,
  EditPersonalInfo,
  EditPrescription,
  EditPrescriptionOfPatient,
  EditPrice,
  ExportPdfPage,
  FamilyHistory,
  ForgotPassword,
  GeneralSearch,
  HelpCenter,
  Home,
  LocationInfo,
  Login,
  MedicalRecord,
  MedicalRecordTemplates,
  Medications,
  MyPrescriptions,
  NewFollowUp,
  NotFound,
  NotificationPage,
  NotificationsSetting,
  OpenInApp,
  PatientMedicalRecordDetails,
  PatientMedicalRecords,
  PatientProfile,
  PatientsList,
  PdfPage,
  PrescriptionsByDoctors,
  PrescriptionsByMe,
  PrescriptionsDetails,
  Price,
  PrivacyPolicy,
  Profile,
  ProviderContactInfo,
  RegisterPasswordStep,
  ResetPassword,
  ScheduleList,
  ScheduleListAdd,
  SecurityQuestionCheck,
  SelectAccountType,
  ServiceProviderProfile,
  SettingLayout,
  SignUp,
  TermsAndConditions,
  UploadDegreeDocument,
  UserBlocked,
  VerifyCodeForgetPassword,
  VerifyCodeRegister,
  VerifyNewPhoneNumber,
} from "../pages";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoutes";
import PatientOdontogram from "../pages/NewMedicalRecord/component/DentestCharts/AdvancedChart/1PatientOdontogram";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/sign-up"
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
      />
      <Route
        path="/verify-code-register"
        element={
          <PublicRoute>
            <VerifyCodeRegister />
          </PublicRoute>
        }
      />
      <Route
        path="/verify-code-forget-Password"
        element={
          <PublicRoute>
            <VerifyCodeForgetPassword />
          </PublicRoute>
        }
      />
      <Route path="/forgot-Password" element={<ForgotPassword />} />
      <Route
        path="/select-account-type"
        element={
          <PublicRoute>
            <SelectAccountType />
          </PublicRoute>
        }
      />
      <Route
        path="/upload-degree-document"
        element={
          <PublicRoute>
            <UploadDegreeDocument />
          </PublicRoute>
        }
      />
      <Route
        path="/password-register"
        element={
          <PublicRoute>
            <RegisterPasswordStep />
          </PublicRoute>
        }
      />
      <Route
        path="/security-questions"
        element={
          <PublicRoute>
            <SecurityQuestionCheck />
          </PublicRoute>
        }
      />
      <Route
        path="/user-blocked"
        element={
          <PublicRoute>
            <UserBlocked />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-Password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
      <Route path="privacy_policy" element={<PrivacyPolicy />} />
      <Route
        path="forget_password/:setting"
        element={
          <ProtectedRoute>
            <ForgotPassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="verify-code-forget-password/:setting"
        element={
          <ProtectedRoute>
            <VerifyCodeForgetPassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/security-questions/:setting"
        element={
          <ProtectedRoute>
            <SecurityQuestionCheck />
          </ProtectedRoute>
        }
      />
      <Route
        path="reset-password/:setting"
        element={
          <ProtectedRoute>
            <ResetPassword />
          </ProtectedRoute>
        }
      />
      <Route path="pdf/:Id" element={<PdfPage />} />
      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Template />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="articles" element={<Articles />} />
        <Route path="articles/:id" element={<ArticleDetails />} />
        <Route path="articles/:id/:title" element={<ArticleDetails />} />
        <Route path="profile" element={<Profile />}>
          <Route index element={<EditPersonalInfo />} />
          <Route path="doctor_specialty" element={<DoctorSpecialty />} />
          <Route path="doctor_certificate" element={<DoctorCertificate />} />
          <Route
            path="doctor_certificate/:id"
            element={<DoctorCertificateDetails />}
          />
          <Route path="clinic_schedule" element={<ScheduleList />} />
          <Route path="clinic_schedule/add" element={<ScheduleListAdd />} />
          <Route path="clinic_address" element={<ClinicAddress />} />
          <Route path="clinic_address/edit" element={<EditClinicAddress />} />
          <Route path="contact_info" element={<ContactInfo />} />
          <Route path="contact_info/edit" element={<EditContactInfo />} />
          <Route path="price" element={<Price />} />
          <Route path="price/edit" element={<EditPrice />} />
          <Route
            path="patients_list"
            element={
              <>
                <PatientsList />
              </>
            }
          />
        </Route>
        <Route
          path="patients_list"
          element={
            <>
              <PatientsList />
            </>
          }
        />
        <Route
          path="patients_list/:id"
          element={
            <>
              <PatientProfile />
            </>
          }
        >
          <Route path="medications" element={<Medications />} />
          <Route path="prescriptions_by_me" element={<PrescriptionsByMe />} />

          <Route
            path="prescriptions_by_doctors"
            element={<PrescriptionsByDoctors />}
          />
          <Route path="allergy" element={<Allergy />} />
          <Route path="chronic_diseases" element={<ChronicDiseases />} />
          <Route path="family_history" element={<FamilyHistory />} />
          <Route path="medical-records" element={<PatientMedicalRecords />} />
        </Route>
        <Route
          path="patients_list/:id/medications/mobile"
          element={<Medications className="box h-full overflow-y-auto" />}
        />
        <Route
          path="patients_list/:id/prescriptions_by_me/mobile"
          element={<PrescriptionsByMe className="box" />}
        />
        <Route
          path="patients_list/:id/prescriptions_by_doctors/mobile"
          element={<PrescriptionsByDoctors className="box" />}
        />
        <Route
          path="patients_list/:id/prescriptions_by_doctors/details/:accountId"
          element={<PrescriptionsDetails />}
        />
        <Route
          path="patients_list/:id/allergy/mobile"
          element={<Allergy className="box" />}
        />
        <Route
          path="patients_list/:id/chronic_diseases/mobile"
          element={<ChronicDiseases className="box" />}
        />
        <Route
          path="patients_list/:id/family_history/mobile"
          element={<FamilyHistory className="box" />}
        />
        <Route path="search" element={<GeneralSearch />} />
        <Route path="search/:Name/:Id" element={<ServiceProviderProfile />}>
          <Route index element={<ProviderContactInfo />} />
          <Route path="contact" element={<ProviderContactInfo />} />
          <Route path="location" element={<LocationInfo />} />
          <Route path="certificates" element={<DoctorCertificates />} />
          <Route
            path="certificates/:certificateId"
            element={<DoctorCertificates />}
          />
        </Route>
        <Route path="my_prescriptions" element={<MyPrescriptions />} />
        <Route
          path="/create_prescription_template"
          element={<CreatePrescriptionTemplate />}
        />
        <Route
          path="/my_prescriptions/edit/:prescriptionId"
          element={<EditPrescription />}
        />
        <Route
          path="/add_prescription_by_template/:PatientId"
          element={<AddPrescriptionToPatientByTemplate />}
        />
        <Route
          path="/edit_prescription_of_patient/:PatientId"
          element={<EditPrescriptionOfPatient />}
        />
        <Route
          path="/add_prescription_to_patient/:PatientId"
          element={<AddPrescriptionToPatient />}
        />
        <Route
          path="/add_prescription_to_patient/:PatientId/:PrescriptionId"
          element={<AddPrescriptionToPatient />}
        />
        <Route path="setting" element={<SettingLayout />}>
          <Route
            index
            element={<Navigate to="notifications_setting" replace />}
          />
          <Route index path="account_setting" element={<AccountSetting />} />
          <Route path="about_us" element={<AboutUs />} />
          <Route path="about_dome_care" element={<AboutUs />} />
          <Route path="help_center" element={<HelpCenter />} />
          <Route
            path="notifications_setting"
            element={<NotificationsSetting />}
          />
          <Route path="privacy_policy" element={<DomeCarePrivacyPolicy />} />
          <Route path="terms_and_conditions" element={<TermsAndConditions />} />
        </Route>
        <Route
          path="notifications"
          element={
            <ProtectedRoute>
              <NotificationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="appointments"
          element={
            <ProtectedRoute>
              <AppointmentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="appointments/add_new_appointment"
          element={
            <ProtectedRoute>
              <AddNewAppointmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="appointments/add_new_appointment/:id"
          element={
            <ProtectedRoute>
              <AddNewAppointmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="appointments/:appointmentId"
          element={
            <ProtectedRoute>
              <AppointmentsPage />
            </ProtectedRoute>
          }
        />
      
          <Route
            path="/medical-record-templates"
            element={
              <>
                <MedicalRecordTemplates />
              </>
            }
          />
     
        {/* {Constants.VERSION_2 && (
          <Route
            path="/medical-record-templates"
            element={
              <ProtectedRoute>
                <PatientMedicalRecords />
              </ProtectedRoute>
            }
          />
        )} */}
      </Route>
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/change-phone-number/add-new"
        element={
          <ProtectedRoute>
            <AddNewPhoneNumber />
          </ProtectedRoute>
        }
      />
      <Route
        path="/send-code-change-number"
        element={
          <ProtectedRoute>
            <VerifyNewPhoneNumber />
          </ProtectedRoute>
        }
      />
      {/* Not Found Route */}
      <Route path="*" element={<NotFound />} />
      <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      <Route
        path="/:lang/download/:endpoint/:token/:Id"
        element={<ExportPdfPage />}
      />
      <Route
        path="/:lang/download/:endpoint/:token"
        element={<ExportPdfPage />}
      />
      <Route path="/pdf-download" element={<PdfPage />} />
      <Route path="/open-in-app/*" element={<OpenInApp />} />
      {/* Version 2 */}
      <Route
        path="patients_list/:id/medical-records/:recordId"
        element={
          <>
            <PatientMedicalRecordDetails />
          </>
        }
      />
      <Route
        path="patients_list/:id/medical-records/all/details"
        element={
          <div className="box">
            <PatientMedicalRecords />
          </div>
        }
      />
      <Route
        path="patients_list/:id/medical-records/all/details/:recordId"
        element={
          <>
            <PatientMedicalRecordDetails />
          </>
        }
      />
     
        <Route
          path="/patient/:PatientId/add-medical-record"
          element={
            <>
              <AddPatientMedicalRecord />
            </>
          }
        />
     
        <Route
          path="/medical-record-templates/:templateId/:type"
          element={
            <>
              <MedicalRecord />
            </>
          }
        />
        <Route
          path="/patients_list/:PatientId/medical-records/new-followup"
          element={
            <>
              <NewFollowUp />
            </>
          }
        />
        <Route
          path="/patients_list/:PatientId/medical-records/:recordId/new-followup"
          element={
            <>
              <NewFollowUp />
            </>
          }
        />
    
        <Route
          path="/patient/:PatientId/add-medical-record/:templateId"
          element={
            <>
              <MedicalRecord />
            </>
          }
        />
   
        <Route
          path="/patient/:PatientId/add-medical-record/:templateId/:type"
          element={
            <>
              <MedicalRecord />
            </>
          }
        />
    
        <Route
          path="/medical-record-templates/:templateId/:type"
          element={
            <>
              <MedicalRecord />
            </>
          }
        />
   
        <Route
          path="/patient/:PatientId/medical_record/:templateId/:type"
          element={
            <>
              <MedicalRecord />
            </>
          }
        />
     
      <Route
        path="/patient/:PatientId/medical-records"
        element={
          <>
            <></>
            {/* <PatientMedicalRecords /> */}
          </>
        }
      />
      {/* <Route
        path="/patients_list/:PatientId/dental-chart"
        element={
          <PatientOdontogram />
        }
      /> */}
      
    </Routes>
  );
};

export default AppRoutes;
